import * as React from "react";

function SvgTrafficGuard(props, ref) {
  return (
    <svg
      viewBox="900 4 135 145"
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit={1.414}
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path
        d="M1000 44.03V0l-8.688 18.3-50.064 33.834v33.071L1000 44.031z"
        fill="#ef575c"
        fillRule="nonzero"
      />
      <path
        d="M992.713 82.132V49.054l-58.746 41.174V123.3l58.746-41.17z"
        fill="#00303e"
        fillRule="nonzero"
      />
      <path
        d="M973.608 119.378v-18.213l-32.361 22.677v27.897l6.555-14.277 25.806-18.084z"
        fill="#ef575c"
        fillRule="nonzero"
      />
    </svg>
  );
}

export default React.forwardRef(SvgTrafficGuard);
